"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeFormControlStyles = function (_a) {
    var isAutoFilledActive = _a.isAutoFilledActive, isSafari = _a.isSafari, theme = _a.theme;
    var autofillColor = isSafari ? 'rgb(250, 255, 189)' : 'rgb(232, 240, 254)';
    return (0, react_1.css)(__assign({ '& .MuiInputLabel-shrink + .MuiInputBase-root input': {
            padding: '28px 55px 11px 0',
            paddingLeft: theme.mvf.spacing.medium,
        }, '& .MuiInputBase-root .MuiInputAdornment-root + input': {
            paddingLeft: 0,
        }, '& .MuiInputLabel-shrink + .MuiInputBase-root .MuiSelect-root': {
            padding: '28px 55px 11px 0',
            paddingLeft: theme.mvf.spacing.medium,
        }, '& .MuiInputBase-root .MuiInputAdornment-root + .MuiSelect-root': {
            paddingLeft: 0,
        }, '& .MuiFormLabel-root + .MuiInputBase-root .MuiInputAdornment-positionStart': {
            marginTop: '16px',
        }, '& .MuiFormLabel-root': {
            lineHeight: 1.6,
        }, '& .MuiFormHelperText-root': {
            marginTop: theme.mvf.spacing.small,
            paddingLeft: theme.mvf.spacing.medium,
            fontSize: theme.mvf.fontSize.small,
        }, '& .MuiSelect-icon': {
            right: theme.mvf.spacing.medium,
        }, '@supports (selector(:has(*)))': {
            '& .MuiInputBase-root:has(input:-webkit-autofill)': {
                backgroundColor: "".concat(autofillColor),
            },
        }, '@supports not (selector(:has(*)))': {
            '& input:-webkit-autofill': {
                backgroundColor: "".concat(autofillColor),
            },
            '& input:-webkit-autofill::first-line': {
                backgroundColor: "".concat(autofillColor),
            },
        } }, (isAutoFilledActive && {
        '& .MuiInputBase-root': {
            backgroundColor: autofillColor,
        },
    })));
};
exports.default = makeFormControlStyles;
//# sourceMappingURL=makeFormControlStyles.js.map